// MentionsLegales.txt
import React from "react";

const MentionsLegales = () => {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>Mentions légales</h1>
        <p>Dernière mise à jour : {LAST_UPDATE}</p>
      </div>

      <section className="legal-section">
        <h2>Éditeur du site</h2>
        <p>
          Nom commercial : <strong>{TRADE_NAME}</strong>
          <br />
          Statut : <strong>Entrepreneur individuel</strong>
          <br />
          Responsable / Directeur de la publication : <strong>{OWNER_FULLNAME}</strong>
          <br />
          Adresse : {BUSINESS_ADDRESS}
          <br />
          SIRET : {SIRET}
          <br />
          Code APE : {APE_CODE}
          <br />
          Date d’immatriculation au RNE : {RNE_DATE}
          <br />
          Email : <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          {CONTACT_PHONE ? (
            <>
              <br />
              Téléphone : <a href={`tel:${CONTACT_PHONE}`}>{CONTACT_PHONE}</a>
            </>
          ) : null}
        </p>
      </section>

      <section className="legal-section">
        <h2>Hébergement</h2>
        <p>
          Le site est hébergé sur un VPS par <strong>Infomaniak Network SA</strong>.
          <br />
          Adresse : Rue Eugène-Marziano 25, 1227 Les Acacias (Genève), Suisse
          <br />
          Site :{" "}
          <a href="https://www.infomaniak.com" target="_blank" rel="noreferrer">
            https://www.infomaniak.com
          </a>
        </p>
      </section>

      <section className="legal-section">
        <h2>Propriété intellectuelle</h2>
        <p>
          L’ensemble des contenus présents sur le site (textes, images, graphismes, logo, etc.) est
          protégé par le droit de la propriété intellectuelle. Toute reproduction, représentation,
          modification, publication, adaptation, totale ou partielle, est interdite sauf autorisation
          écrite préalable.
        </p>
      </section>

      <section className="legal-section">
        <h2>Responsabilité</h2>
        <p>
          L’éditeur s’efforce de fournir des informations aussi précises que possible. Toutefois, il ne
          pourra être tenu responsable des omissions, des inexactitudes et des carences dans la mise à
          jour, qu’elles soient de son fait ou du fait des tiers partenaires.
        </p>
      </section>
    </div>
  );
};

// ✅ Données fournies + à compléter
const LAST_UPDATE = "2026-02-19";

const TRADE_NAME = "ToCreate";
const OWNER_FULLNAME = "Loic SUNVÉ ÉRIMÉE";
const BUSINESS_ADDRESS = "6 ALL de la Palme d'Or, 78300 Poissy, FRANCE";

const SIRET = "83474430200037";
const APE_CODE = "6201Z";
const RNE_DATE = "18/02/2026";

const CONTACT_EMAIL = "contact@tocreate.fr"; // adapte si besoin
const CONTACT_PHONE = ""; // optionnel

export default MentionsLegales;
